import ecom from "../assets/ecom.webp";
import portfolio from "../assets/portfolio.jpg";
import dashboard from "../assets/dashboard.jpg";
import mobileApp from "../assets/react mobile app.webp";
import socialmedia from "../assets/social media.jpg";
import corporate from "../assets/corporate.webp";
import crm from "../assets/crm.jpg";
import educatiom from "../assets/education.jpg";
import estate from "../assets/estate.png";
import social from "../assets/social.png";
import elearning from "../assets/elearning.png";
import travel from "../assets/travel.png";
import inventory from "../assets/inventory.webp";
import fitness from "../assets/fitness.png";
import event from "../assets/event.png";
import online from "../assets/online.png";
import blog from "../assets/blog.webp";
import craft from "../assets/craft.jpg";
import job from "../assets/job.webp";
import egovernence from "../assets/egovernence.jpg";
export const projects = [
  {
    title: "E-Commerce Platform",
    description:
      "Developed a scalable e-commerce platform with real-time search and secure payment integration.",
    technologies: ["React", "Node.js", "MongoDB", "Stripe API"],
    features: [
      "User authentication",
      "Dynamic product filtering",
      "Integrated payment gateway",
    ],
    image: ecom,
  },
  {
    title: "Creative Portfolio",
    description:
      "Designed a visually stunning and user-friendly portfolio for a creative agency.",
    technologies: ["Next.js", "Framer Motion", "Material-UI"],
    features: ["Animated transitions", "Responsive design", "SEO optimized"],
    image: portfolio,
  },
  {
    title: "Analytics Dashboard",
    description:
      "Built a custom analytics dashboard to track KPIs and generate actionable insights.",
    technologies: ["React", "Redux", "Chart.js", "Firebase"],
    features: [
      "Real-time data visualization",
      "Customizable widgets",
      "User role management",
    ],
    image: dashboard,
  },
  {
    title: "Mobile App Development",
    description:
      "Developed a cross-platform mobile app with advanced features and a sleek UI.",
    technologies: ["React Native", "Expo", "Firebase"],
    features: ["Push notifications", "Offline mode", "Cross-platform support"],
    image: mobileApp,
  },
  {
    title: "Social Media Campaign",
    description:
      "Created a highly engaging social media marketing campaign for a leading brand.",
    technologies: ["Canva", "Hootsuite", "Facebook Ads"],
    features: ["Audience targeting", "Analytics tracking", "Content creation"],
    image: socialmedia,
  },
  {
    title: "Corporate Website",
    description:
      "Designed a modern and responsive website for a multinational company.",
    technologies: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    features: ["Responsive design", "SEO optimized", "Fast loading speed"],
    image: corporate,
  },
  {
    title: "Custom CRM System",
    description:
      "Developed a custom CRM system tailored to the client’s business processes.",
    technologies: ["PHP", "MySQL", "Laravel"],
    features: [
      "Contact management",
      "Sales tracking",
      "Automated email follow-ups",
    ],
    image: crm,
  },
  {
    title: "Educational Platform",
    description:
      "Created an e-learning platform for online courses and training sessions.",
    technologies: ["Moodle", "PHP", "MySQL"],
    features: [
      "Interactive quizzes",
      "Course tracking",
      "User progress reports",
    ],
    image: educatiom,
  },
  {
    title: "Real Estate App",
    description:
      "Built a mobile app for property listings with location-based search and filtering.",
    technologies: ["Flutter", "Dart", "Firebase"],
    features: ["Map integration", "Favorites list", "Chat support"],
    image: estate,
  },
  {
    title: "Social Media Scheduler",
    description:
      "Developed a tool to schedule social media posts across multiple platforms.",
    technologies: ["Node.js", "MongoDB", "React"],
    features: [
      "Multi-platform support",
      "Scheduled posting",
      "Engagement analytics",
    ],
    image: social,
  },
  {
    title: "E-Library System",
    description:
      "Designed a digital library system for easy access to books and research material.",
    technologies: ["Python", "Django", "PostgreSQL"],
    features: ["Search functionality", "E-book support", "User management"],
    image: elearning,
  },
  {
    title: "Travel Booking Website",
    description:
      "Built a responsive travel booking website for vacation planning.",
    technologies: ["Vue.js", "Node.js", "MongoDB"],
    features: [
      "Flight booking",
      "Hotel reservations",
      "Payment gateway integration",
    ],
    image: travel,
  },
  {
    title: "Inventory Management System",
    description:
      "Developed a comprehensive inventory management system for a retail chain.",
    technologies: ["PHP", "CodeIgniter", "MySQL"],
    features: ["Stock tracking", "Low stock alerts", "Detailed reporting"],
    image: inventory,
  },
  {
    title: "Fitness Tracker App",
    description:
      "Created a mobile app to help users track their workouts and health stats.",
    technologies: ["React Native", "Firebase"],
    features: ["Workout tracking", "Progress charts", "Community features"],
    image: fitness,
  },
  {
    title: "Event Management System",
    description:
      "Built a system to manage event registrations, scheduling, and attendee tracking.",
    technologies: ["Laravel", "MySQL"],
    features: ["Attendee management", "Ticketing system", "Event analytics"],
    image: event,
  },
  {
    title: "Online Learning App",
    description:
      "Developed an app to provide online learning resources and quizzes.",
    technologies: ["Flutter", "Firebase"],
    features: ["Video lessons", "Interactive quizzes", "Progress tracking"],
    image: online,
  },
  {
    title: "Personal Blog Platform",
    description:
      "Designed a blogging platform with a user-friendly interface and advanced SEO features.",
    technologies: ["WordPress", "PHP"],
    features: ["SEO tools", "Customizable themes", "Content scheduling"],
    image: blog,
  },
  {
    title: "Online Store for Handicrafts",
    description:
      "Built an online marketplace for artisans to sell their handmade products.",
    technologies: ["Magento", "PHP", "MySQL"],
    features: [
      "Product listing",
      "Order tracking",
      "Integrated payment system",
    ],
    image: craft,
  },
  {
    title: "Job Portal",
    description:
      "Developed a job portal for job seekers and employers to connect efficiently.",
    technologies: ["React", "Node.js", "MongoDB"],
    features: ["Resume uploads", "Job filtering", "Company profiles"],
    image: job,
  },
  {
    title: "E-Governance Platform",
    description:
      "Designed a platform for efficient management of government services.",
    technologies: ["Angular", "Node.js", "MySQL"],
    features: [
      "Service request tracking",
      "Secure document management",
      "Citizen portal",
    ],
    image: egovernence,
  },
];
